import { Totals, TotalSubscriptions } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

export const getTotals = async (_): Promise<Totals> =>
  fetchFromAPI(`/totals`, { cdn: true });

export const getTotalSubscriptions = async (_): Promise<TotalSubscriptions> =>
  fetchFromAPI(`/totals/subscriptions`, { cdn: true });
